<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Integration partner details"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Integration Partner Details'"
    [altColor]="false"
    [actions]="headerButtonActions()"
  >
  </aw-divider>

  <div class="info-container">
    <div>
      @for (item of integrationInfoDividers(); track $index) {
      <div class="inset">
        <span class="inset-title">{{ item.title }}</span>
        <span class="inset-info">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="divider-container">
      @for (item of integrationDateDividers(); track $index) {
      <div class="inset">
        <span class="inset-title">{{ item.title }}</span>
        <span class="inset-info">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="customers-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Integration Customers'"
        [altColor]="false"
        [altColor]="true"
      >
      </aw-divider>
      <div class="table-form-container" [ngClass]="container_theme()">
        <div>
          <aw-search
            [(ngModel)]="customerSearchValue"
            (ngModelChange)="onSearchTable(customerSearchValue)"
            ariaLabel="search-menu"
            [placeholder]="'Search'"
          >
            <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
          </aw-search>
        </div>

        @if (organization === 'assetworks-employee' && userPermissions['canEdit']) {
        <Button
          AwButton
          [disable]="disableCustomerChangeStatus"
          (click)="openChangeCustomerStatus = true"
          >Change Status</Button
        >
        <Button
          AwButton
          [disable]="disableCustomerAssociate"
          (click)="openAssociateCustomerDialog = true"
        >Associate</Button
        >
        }
      </div>
      <aw-table
        [columnsDefinition]="customersColumnsDefinition"
        [tableData]="customersTableData()"
        [sortDisabled]="false"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>

      <aw-dialog
        [visible]="openDeleteCustomerDialogSingle"
        [dialogOptions]="dialogOptionsDeleteSingle"
        (primaryAction)="deleteCustomerFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('delete')"
        ariaLabel="Disassociate customer"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openChangeCustomerStatus"
        [formFieldsData]="changeStatusFormFields()"
        [dialogOptions]="dialogOptionsChangeStatus"
        (primaryAction)="changeCustomerStatusFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('change-status')"
        ariaLabel="Change customer status"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openAssociateCustomerDialog"
        [dialogOptions]="dialogOptionsAssociate"
        (primaryAction)="associateCustomersFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('associate')"
        ariaLabel="Associate customer"
      >
      </aw-dialog>
    </div>

    @if (hasAssociatedCustomers()) {
      <div class="api-access-container">
        <aw-divider
          [inset]="false"
          [middleInset]="false"
          [subTitle]="'API Access'"
          [altColor]="true"
        ></aw-divider>

        <app-aw-dropdown-form
          [options]="associatedCustomerOptions()"
          [title]="'Select Customer'"
          (currentOption)="onCustomerSelected($event)"
        ></app-aw-dropdown-form>

        @if (selectedCustomerId) {
          <app-api-access-section
            [organizationId]="selectedCustomerId"
            [authorizedParty]="integrationInfo?.organizationId ?? ''"
            [showHeading]="false"
            (toastMessage)="buildToastMessage($event.message, $event.variant)"
          ></app-api-access-section>
        }
      </div>
    }
  </div>
</div>
